module.exports = __webpack_public_path__ + "static/media/example_can_load.ff276079.png";